import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const bookingExperienceListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fcustomerbooking%2Fcustomer-booking-seo-image.png?alt=media&token=9667c467-7601-4c83-b1cf-ba8fefb4ab77",
  title: "Customer Experience",
  subtitle: "Seamless Bookings on any Device",
  page: WildNavigationType.BOOKINGEXPERIENCE,
}